export const SET_SEARCH_CLAIM = 'SET_SEARCH_CLAIM';
